import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

export function ProfileLink({ name }) {
  return (
    <a
      href={`/profile/${name}`}
      target="_blank"
      className="button button--primary button--no-margin"
      rel="noopener noreferrer"
    >
    View profile
    </a>
  );
}

ProfileLink.propTypes = {
  name: PropTypes.string.isRequired,
};

const mapStateToProps = ({ myself: { character: { name } } }) => ({ name });

export default connect(mapStateToProps)(ProfileLink);